import React, { useEffect, useState } from 'react'

/**
 * PC_Sc_04 getSpotlightData gets imported from api.js file
 */
import { getSpotlightData } from '../service/api'
import '../components/css/Dashboard-styles.css';




const SpotlightData = () => {

    /**
 * PC_Sc_02
 * The data state variable is created for storing the response data
 */

    const [data, setData] = useState([])

    /**
  * PC_Sc_03
  * Use Efffect method is called 
  */

    useEffect(() => {

        fetchApi()

    }, [])


    /**
 * PC_Sc_06
 * The fetchApi function in the useEffects gets invoked which inturn call the getSpotlightData() function with respective parameters
 */

    const fetchApi = async () => {

        const resp = await getSpotlightData()

        if (resp?.data?.ResponseData.length) setData(resp.data.ResponseData)

    }

    /**
     * PC_Sc_10
     * The response data gets stored in the data variable and mapped to respective divs
     */


    const spotlightBody = () => {

        try {

            if (data.length) {

                return (data.map((datum, i) => {

                    return (
                        <>
                            <div className={`carousel-item ${(i == 0) ? 'active' : ""} dashboard-custom-announcements-height`}>
                                <div className="d-flex justify-content-between p-3 ">
                                    <h1 className="tt-bold font-15 d-flex mt-2">Spotlight</h1>
                                    <label><img src={(datum.hasOwnProperty('years') ? `/Images/Anniversary Image.png` : `/Images/Birthday Image.png`)} className="dashboard-style-22" /></label>
                                </div>
                                <div className="text-center">
                                    <span><img src="/Images/logo-person-user-person-icon.jpg" className="dashboard-spotlight-image-size" /></span>
                                    <h3 className="tt-bold font-22 mt-4 dashboard-activities-count">{(datum.hasOwnProperty('years') ? `Happy ${datum.years} year Anniversary` : `Happy BirthDay`)}</h3>
                                    <h5 className="tt-bold font-18 mt-1 dashboard-color-purple">{datum.emp_name}</h5>
                                </div>
                            </div>
                        </>

                    )
                })

                )
            }
            else {


                return (

                    <div className={`carousel-item active dashboard-custom-announcements-height`}>
                        <div className="d-flex justify-content-between p-3 ">
                            <h1 className="tt-bold font-15 d-flex mt-2">Spotlight</h1>
                            {/* <label><img className="dashboard-style-22 rounded-circle" /></label> */}
                        </div>
                        {/* <div className="text-center">
                        <span><img src="/Images/Profile Pic.png" className="dashboard-spotlight-image-size" /></span>
                        <h3 className="tt-bold font-22 mt-4 dashboard-activities-count">{(datum.hasOwnProperty('years') ? `Happy ${datum.years} year Anniversary` : `Happy BirthDay`)}</h3>
                        <h5 className="tt-bold font-18 mt-1 dashboard-color-purple">{datum.emp_name}</h5>
                    </div> */}
                    </div>

                )
            }


        }
        catch (err) {


        }

    }

    return (
        <div id="carouselExampleControls" className="carousel slide carousel-fade custom-carousel-fade" data-bs-ride="carousel">
            <div className="carousel-inner">
                {spotlightBody()}
            </div>

            {data.length > 1 ? <>
                <button className="carousel-control-prev dashboard-custom-announcements-height" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next dashboard-custom-announcements-height" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                </button>
            </> : <></>}


        </div>
    )
}

export default SpotlightData